import { useState } from 'react';
import { ShoppingBag } from 'lucide-react';
import { proxyImage } from '@/lib/imageProxy';

type Stage = 'proxy' | 'direct' | 'fail';

/**
 * Imagem com fallback em cascata:
 * proxy (weserv/storage) → URL direta da loja → ícone de sacola.
 * Evita o ícone de imagem quebrada quando o proxy falha no navegador.
 */
export function SmartImage({
  url,
  alt = '',
  className,
  w,
  h,
  iconClassName = 'h-5 w-5 text-muted-foreground',
}: {
  url?: string | null;
  alt?: string;
  className?: string;
  w?: number;
  h?: number;
  iconClassName?: string;
}) {
  const [stage, setStage] = useState<Stage>(() => {
    if (!url) return 'fail';
    const proxied = proxyImage(url, { w, h });
    return proxied && proxied !== url ? 'proxy' : 'direct';
  });
  if (!url || stage === 'fail') return <ShoppingBag className={iconClassName} aria-hidden="true" />;
  const proxied = proxyImage(url, { w, h });
  const src = stage === 'proxy' && proxied ? proxied : url;
  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      decoding="async"
      referrerPolicy="no-referrer"
      className={className}
      onError={() => setStage(stage === 'proxy' && proxied && proxied !== url ? 'direct' : 'fail')}
    />
  );
}
